var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" Visualizar Organograma ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.nome,
      "label": "Nome da Gerência",
      "outlined": "",
      "readonly": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.sigla,
      "label": "Sigla da Gerência",
      "outlined": "",
      "readonly": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.secretariaExecutiva.nome,
      "label": "Secretaria Executiva",
      "outlined": "",
      "dense": "",
      "readonly": ""
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Setor(es)",
      "items": _vm.form.lists.setores,
      "item-text": 'nome',
      "item-value": 'id',
      "outlined": "",
      "multiple": "",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: _vm.content.setores,
      callback: function ($$v) {
        _vm.$set(_vm.content, "setores", $$v);
      },
      expression: "content.setores"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "btn-group text-center mt-7"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }